import React from 'react';
import PropTypes from 'prop-types';
import DevTools from '../DevTools';
import styles from './styles.module.scss';
import Sidenav from '../../Sidenav/Root';
import UpdateModal from '../../Cart/UpdateModal';
import enhance from './enhance';
import SavingWorkingStateModal from '../../shared/SavingWorkingStateModal';
import LockExpirationModal from '../../OrderDashboard/LockExpirationModal';

const Layout = ({ children, withCartModal, withSidenav, mini }) => (
  <div className={mini ? styles.miniBody : styles.bmwBody}>
    <SavingWorkingStateModal />
    <LockExpirationModal />
    {withCartModal && <UpdateModal />}
    {withSidenav && <Sidenav />}
    {children}
    <DevTools />
  </div>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default enhance(Layout);
